<app-breadcrumb *ngIf="!insuranceCompanyObject" [master]="'Struktura sieci'" [parentName]="'TU'" [name]="'Dodaj'"></app-breadcrumb>
<div class="insurance-company-add" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
    <button (click)="save()"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

    <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column">
        <div fxLayout="row">
          <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
              <div fxLayout="row">
                <h3>Dane Tu</h3>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
<!--                <div fxFlex="50">-->
<!--                  <mat-form-field fxFlex="100">-->
<!--                    <mat-label>Klucz</mat-label>-->
<!--                    <input matInput placeholder="europ_assistance"  [formControl]="keyControl" >-->
<!--                  </mat-form-field>-->
<!--                </div>-->

                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Nazwa</mat-label>
                    <input matInput placeholder="EUROP ASSISTANCE"  [formControl]="nameControl" >
                  </mat-form-field>
                </div>

                <div fxFlex="50" >
                  <mat-form-field fxFlex="100">
                    <mat-label>Typ</mat-label>
                    <mat-select [formControl]="typeControl">
                      <mat-option value = "assets">Majątek</mat-option>
                      <mat-option value = "life">Życie</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

              </div>
              <div fxLayout="row" fxLayoutGap="15px">

                <div fxFlex="100">
                  <mat-form-field fxFlex="100">
                    <mat-label>Pełna nazwa</mat-label>
                    <input matInput placeholder="Europ Assistance SA - oddział w Irlandii"  [formControl]="fullNameControl" >
                  </mat-form-field>
                </div>

              </div>

              <div fxLayout="row" fxLayoutGap="15px">

                <div fxFlex="20">
                  <mat-slide-toggle color="accent" [formControl]="inactiveControl"> Aktywne</mat-slide-toggle>
                </div>

                <div fxFlex="20">
                  <mat-slide-toggle color="accent" [formControl]="cessionControl"> Cesja</mat-slide-toggle>
                </div>

                <div fxFlex="20">
                  <mat-slide-toggle color="accent" [formControl]="identifiersControl"> Identyfikatory</mat-slide-toggle>
                </div>
                <div fxFlex="20" *ngIf="insuranceCompanyObject">
                  <mat-slide-toggle color="accent" [formControl]="loginControl"> Loginy</mat-slide-toggle>
                </div>

                <div fxFlex="20" *ngIf="cessionControl.value && insuranceCompanyObject">
                  <mat-slide-toggle color="accent" [formControl]="cessionLoginControl"> Loginy Cesja</mat-slide-toggle>
                </div>

            </div>
          </mat-card>
        </div>

        <div fxLayout="row" *ngIf="loginControl.value && insuranceCompanyObject">
          <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
            <div fxLayout="row">
              <h3>Login</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100" >

                <app-dict
                  [label]="'Login'" dictType="registration_id_type"
                  [required]="false" [multiple]="true"
                  [control]="loginsHelpControl"  appearance="fill"
                  [color]="true" [onlyKeys]="selectedValues"
                ></app-dict>
              </div>

            </div>
          </mat-card>
        </div>

        <div fxLayout="row" *ngIf="cessionLoginControl.value && insuranceCompanyObject ">
          <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
            <div fxLayout="row">
              <h3>Login Cesja</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100" >

                <app-dict
                  [label]="'Login Cesja'" dictType="registration_id_type"
                  [required]="false" [multiple]="true"
                  [control]="cessionLoginsHelpControl"  appearance="fill"
                  [color]="true" [onlyKeys]="selectedValues"
                ></app-dict>
              </div>

            </div>
          </mat-card>
        </div>

        <div fxLayout="row" *ngIf="identifiersControl.value">
          <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
            <div fxLayout="row">
              <h3>Identyfikatory</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100" >
                <table fxFlex="100">
                  <tr *ngFor="let sortItem of sortItems">
                    <td *ngFor="let item of sortItem" >
                      <mat-checkbox
                        (change)="add(item)"
                        [checked]="isSelect(item.key)">
                        {{item.name}}
                      </mat-checkbox>
                    </td>
                  </tr>
                </table>
              </div>

            </div>
          </mat-card>
        </div>

        <div fxLayout="row">
          <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
            <div fxLayout="row">
              <h3>Firmy</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="25" >
                <mat-slide-toggle   color="accent" [formControl]="asfControl"> ASF Grzegorz Adamczuk</mat-slide-toggle>
              </div>

            </div>
            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="25" >
                <mat-slide-toggle   color="accent" [formControl]="asfPremiumControl"> ASF Premium</mat-slide-toggle>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="25" >
                <mat-slide-toggle   color="accent" [formControl]="multisferaControl"> Multisfera</mat-slide-toggle>
              </div>

            </div>
          </mat-card>
        </div>

        <div  fxLayout="row" fxFlex.lt-md="100%">
          <div fxFlex="100">
            <mat-card class="partners-add-card" fxLayout="column">
              <div fxLayout="row">
                <h3>
                  Linki do portali
                </h3>
              </div>

              <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of linkToPortalFormArray; index as i">
                <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">
                  <div fxFlex="5" class="list-counter">
                    {{i+1}}.
                  </div>

                  <div fxFlex="90" fxLayoutGap="10px">
                    <div fxFlex="50" >
                      <mat-form-field class="partners-add-input" fxFlex="100">
                        <mat-label>Nazwa</mat-label>
                        <input appCapitalizeFirst matInput placeholder="Nazwa" formControlName="name">
                        <mat-error *ngIf="formGroup.get('name').hasError('required')">To pole jest wymagane</mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="100" >
                      <mat-form-field class="partners-add-input" fxFlex="100">
                        <mat-label>Link</mat-label>
                        <input appCapitalizeFirst matInput placeholder="Link" formControlName="link" [required]="true">
                        <mat-error *ngIf="formGroup.get('link').hasError('required')">To pole jest wymagane</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div fxFlex="5"  fxLayoutGap="15px">
                    <div class="list-remove-button">
                      <button (click)="removeLink(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                </div>

              </div>

              <div fxFlex="100" fxLayout="row">
              <span fxFlex="">
              </span>
                <button (click)="addlink()" mat-stroked-button color="primary">
                  <mat-icon>add_box</mat-icon> <span> Dodaj</span>
                </button>
              </div>
            </mat-card>

          </div>

        </div>

        <div  fxLayout="row" fxFlex.lt-md="100%">
          <div fxFlex="100">
            <mat-card class="partners-add-card" fxLayout="column">
              <div fxLayout="row">
                <h3>
                  Kontakt
                </h3>
              </div>

              <div fxLayout="column" fxFlex="100" >
                <div fxLayout="row" fxLayoutGap="15px" >


                  <div fxFlex="100" fxLayoutGap="10px">
                    <div fxFlex="50" >
                        <mat-form-field fxFlex="100">
                          <mat-label>Infolinia</mat-label>
                          <input matInput placeholder="Infolinia"  [formControl]="contactHelplineControl" >
                        </mat-form-field>
                    </div>
                    <div fxFlex="50" >
                        <mat-form-field fxFlex="100">
                          <mat-label>Adres email</mat-label>
                          <input matInput placeholder="Adres email"  [formControl]="contactEmailControl" >
                        </mat-form-field>
                    </div>
                  </div>


                </div>

              </div>
            </mat-card>

          </div>

        </div>

        <div fxLayout="row">
          <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
            <div fxLayout="row">
              <h3>Wymogi szkoleniowe</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Majątek - godziny</mat-label>
                  <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba godzin - majątek" [formControl]="requiredAssetsHoursPartControl">
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Majątek - minuty</mat-label>
                  <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - majątek" [formControl]="requiredAssetsMinutesPartControl">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Życie - godziny</mat-label>
                  <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba godzin - życie" [formControl]="requiredLifeHoursPartControl">
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Życie - minuty</mat-label>
                  <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - życie" [formControl]="requiredLifeMinutesPartControl">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Ogólne - godziny</mat-label>
                  <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba godzin - ogólne" [formControl]="requiredGeneralHoursPartControl">
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Ogólne - minuty</mat-label>
                  <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - ogólne" [formControl]="requiredGeneralMinutesPartControl">
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>

      </div>
    </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
